import { render, staticRenderFns } from "./BaseSingleSelection.vue?vue&type=template&id=d52aaf1a&scoped=true&"
import script from "./BaseSingleSelection.vue?vue&type=script&lang=js&"
export * from "./BaseSingleSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52aaf1a",
  null
  
)

export default component.exports